import { render, staticRenderFns } from "./ExcDropdownItem.vue?vue&type=template&id=a5195014&scoped=true&"
import script from "./ExcDropdownItem.vue?vue&type=script&lang=js&"
export * from "./ExcDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./ExcDropdownItem.vue?vue&type=style&index=0&id=a5195014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5195014",
  null
  
)

export default component.exports